import { Stack, Typography } from '@mui/material'
import { Button } from '@ds/components'
import type { TPublisherCopyrightDraftReviewSong } from '@modules/types'
import { SONGS_LIST_STRINGS } from './strings'

interface SongsListFooterProps {
  onSendReview: () => void
  isSendingReview: boolean
  isLoading: boolean
  initialLoading: boolean
  isRequestSubmitted: boolean
  songs: Partial<TPublisherCopyrightDraftReviewSong>[]
}

const isSongAnswered = (song: Partial<TPublisherCopyrightDraftReviewSong>) =>
  [
    song.isApproved,
    song.printPublisherShare,
    song.digitalPublisherShare,
    song.copyrightNotice,
  ].some(value => value !== null && value !== undefined) ||
  song.printIsNotOwned === 1 ||
  song.digitalIsNotOwned === 1

export const SongsListFooter = ({
  onSendReview,
  isSendingReview,
  isLoading,
  initialLoading,
  isRequestSubmitted,
  songs,
}: SongsListFooterProps) => {
  const isDisabled = isSendingReview || isLoading || isRequestSubmitted || initialLoading
  return (
    <Stack alignItems="center" gap={1.5} pt={1.5} pb={4} px={4}>
      <Typography sx={{ m: 0, fontSize: 15, color: 'text.secondary' }}>
        {SONGS_LIST_STRINGS.answeredCount(songs.filter(isSongAnswered).length, songs.length)}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={onSendReview}
        disabled={isDisabled}
        loading={isSendingReview}
        sx={{ minHeight: 52, fontSize: 16, fontWeight: 600 }}
      >
        {SONGS_LIST_STRINGS.sendReview}
      </Button>
    </Stack>
  )
}
